define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaSourceStorageTypeDomain = void 0;
    class WaSourceStorageTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaSourceStorageTypeDomain.Tank, value: "Tank" },
                    { key: WaSourceStorageTypeDomain.TurkeysNest, value: "Turkey's Nest" },
                    { key: WaSourceStorageTypeDomain.Dam, value: "Dam" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaSourceStorageTypeDomain.Tank] = 0;
                this.KeyIndex[WaSourceStorageTypeDomain.TurkeysNest] = 1;
                this.KeyIndex[WaSourceStorageTypeDomain.Dam] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Tank"] = 0;
                this.ValueIndex["Turkey's Nest"] = 1;
                this.ValueIndex["Dam"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaSourceStorageTypeDomain = WaSourceStorageTypeDomain;
    Object.defineProperty(WaSourceStorageTypeDomain, "Tank", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaSourceStorageTypeDomain, "TurkeysNest", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaSourceStorageTypeDomain, "Dam", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaSourceStorageTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
